import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["filter-actions", `filter-actions--${_ctx.align}`])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleActions, (action, index) => {
      return (_openBlock(), _createBlock(_component_ButtonComponent, {
        key: action.text || index,
        mod: action.mod,
        class: _normalizeClass(action.class),
        disabled: action.disabled,
        onClick: action.onClick
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(action.text), 1)
        ]),
        _: 2
      }, 1032, ["mod", "class", "disabled", "onClick"]))
    }), 128))
  ], 2))
}